module.exports = __webpack_public_path__ + "static/media/logo.8ddb1709.png";